import React from 'react';

export type FaqPost = {
    answer: React.JSX.Element;
    id: number;
    question: string;
};

export const FAQ_POSTS: FaqPost[] = [
    {
        answer: (
            <ol>
                <li>Haal de batterij uit het WatchPAT® ONE-apparaat</li>
                <li>Doe het apparaat (zonder doos) in een envelop</li>
                <li>
                    Schrijf dit op de voorkant van de envelop:
                    <br />
                    Antwoordnummer 1011
                    <br />
                    8663 ZX LENT
                </li>
                <li>Breng de envelop naar een Post-NL punt of doe het in een brievenbus.</li>
            </ol>
        ),
        id: 1,
        question: 'Wat moet ik doen met de slaaprecorder (WatchPAT), zodra ik klaar ben met het slaaponderzoek?',
    },
    {
        answer: (
            <p>
                Zoek in de mail op &quot;Ksyos&quot;. Controleer of de e-mail niet in de spambox terecht is gekomen. Heb
                je geen e-mail ontvangen? Neem contact met ons op via{' '}
                <a href="mailto:polikliniek@ksyos.nl">polikliniek@ksyos.nl</a>.
            </p>
        ),
        id: 2,
        question: 'Ik heb geen e-mail ontvangen, wat nu?',
    },
    {
        answer: (
            <p>
                Volg de instructies die zijn bijgevoegd bij de WatchPAT. Als je hierover vragen hebt, bel dan met{' '}
                <a href="tel:020-600 00 60">020-600 00 60</a> of mail naar{' '}
                <a href="mailto:polikliniek@ksyos.nl">polikliniek@ksyos.nl</a>. Zorg dat je de vingerprobe (stap 9) pas
                uitvoert wanneer je daadwerkelijk gaat slapen. Dit kan namelijk maar eenmalig!
            </p>
        ),
        id: 3,
        question: 'Ik heb een slaaprecorder (WatchPAT) gekregen, wat moet ik doen?',
    },
    {
        answer: (
            <p>
                De pincode voor de WatchPAT ONE is de laatste 4 cijfers van jouw BSN-nummer. Je hebt 4 pogingen. Als het
                niet lukt, neem dan contact op via <a href="tel:020-600 00 60">020-600 00 60</a> of{' '}
                <a href="mailto:polikliniek@ksyos.nl">polikliniek@ksyos.nl</a>.
            </p>
        ),
        id: 4,
        question: 'Waar vind ik mijn pincode voor de slaaprecorder (WatchPAT)?',
    },
    {
        answer: (
            <p>
                Je slaapt 1 nacht met de slaaprecorder (WatchPAT). In enkele gevallen slaap je maximaal 3 nachten met de
                recorder.
            </p>
        ),
        id: 5,
        question: 'Hoeveel nachten moet ik met de slaaprecorder (WatchPAT) slapen?',
    },
    {
        answer: <p>Nee, je kunt tijdens het slaaponderzoek gewoon naast je partner slapen.</p>,
        id: 6,
        question: 'Is het de bedoeling dat ik tijdens het slaaponderzoek alleen slaap (zonder partner)?',
    },
    {
        answer: <p>Ja, je kan het bed verlaten om bijvoorbeeld naar de wc te gaan.</p>,
        id: 7,
        question: "Kan ik 's nachts mijn bed verlaten met de slaaprecorder?",
    },
    {
        answer: (
            <p>
                Als er binnen 10 werkdagen na het onderzoek geen contact met je is opgenomen, neem dan contact met ons
                op via <a href="tel:020-600 00 60">020-600 00 60</a> of{' '}
                <a href="mailto:polikliniek@ksyos.nl">polikliniek@ksyos.nl</a>.
            </p>
        ),
        id: 8,
        question: 'Ik heb een slaaponderzoek gedaan, maar er is nog geen contact met mij opgenomen?',
    },
    {
        answer: (
            <p>
                Zorg ervoor dat de huid schoon is, zoveel mogelijk vrij van haar en vettige crème. Als de sensor toch
                niet blijft zitten, kun je een extra stukje tape of een pleister gebruiken.
            </p>
        ),
        id: 9,
        question: 'De sensor blijft niet plakken, wat moet ik doen?',
    },
    {
        answer: (
            <p>
                Binnen twee werkdagen bellen wij jou met telefoonnummer <a href="tel:020-600 00 60">020-600 00 60</a> om
                een videoconsult in te plannen. Tijdens dit consult bespreken we uitslag van het slaaponderzoek en
                vragen we naar je klachten. Indien mogelijk wordt er een diagnose gesteld, en bespreken we eventuele
                behandelopties die in gang worden gezet.
            </p>
        ),
        id: 10,
        question: 'Ik heb een slaaprecorder (WatchPAT) gehad. Wat is de volgende stap?',
    },
    {
        answer: (
            <>
                <p>
                    Afhankelijk van de ernst en oorzaak van slaapapneu wordt er samen met jou bepaald welk behandelplan
                    het beste bij jou past.
                </p>
                <p>
                    Er zijn verschillende behandelopties mogelijk: Leefstijl advies, MRA (Mandibulair Repositie
                    Apparaat), Slaap Positie Therapie (SPT), CPAP (Continuous Positive Airway Pressure), of Chirurgische
                    therapie in specifieke gevallen. Kijk voor meer informatie ook in MijnKsyos, hier vind je
                    bijvoorbeeld ook de presentatie van de arts terug.
                </p>
            </>
        ),
        id: 11,
        question: 'Uit het onderzoek is gebleken dat ik een slaapapneu heb, wat nu?',
    },
    {
        answer: (
            <p>
                Binnen 10 werkdagen neemt een van onze leveranciers contact met je op. Dit kan gaan om VIVISOL of
                Vitalair.
            </p>
        ),
        id: 12,
        question: 'Ik heb te horen gekregen dat ik een slaapapparaat krijg als behandeling. Wanneer hoor ik meer?',
    },
    {
        answer: (
            <>
                <p>
                    Voor vragen over het slaapapparaat ben je als het goed is bekend met een van onze leveranciers. Dit
                    kan gaan om VIVISOL of Vitalair.
                </p>
                <p>
                    Bekijk de{' '}
                    <a
                        href="https://www.VIVISOL.nl/veelgestelde-vragen"
                        rel="noreferrer"
                        target="_blank"
                    >
                        veelgestelde vragen van VIVISOL
                    </a>{' '}
                    of neem contact met VIVISOL op.
                </p>
                <p>Of</p>
                <p>
                    Bekijk de{' '}
                    <a
                        href="https://www.vitalair.nl/faq"
                        rel="noreferrer"
                        target="_blank"
                    >
                        veelgestelde vragen van Vitalair
                    </a>{' '}
                    of neem contact met Vitalair op.
                </p>
            </>
        ),
        id: 13,
        question:
            'Ik heb een vraag over mijn slaapapparaat (bijv. over het masker, slang, filter, etc.). Bij wie kan ik mijn vraag stellen?',
    },
    {
        answer: (
            <p>
                De kosten van het slaaponderzoek variëren afhankelijk van jouw zorgverzekeraar en het eigen risico. Veel
                zorgverzekeraars vergoeden dit onderzoek. Neem contact op met jouw zorgverzekeraar voor specifieke
                informatie over vergoeding.{' '}
                <a
                    href="https://ksyos.webflow.io/service/kosten"
                    rel="noreferrer"
                    target="_blank"
                >
                    Ook hier vind je meer informatie over de kosten.
                </a>
            </p>
        ),
        id: 14,
        question: 'Wat zijn de kosten van het slaaponderzoek?',
    },
    {
        answer: (
            <p>
                Ksyos heeft voor het slaaponderzoek geen afspraken met jouw zorgverzekeraar. Daarom kunnen wij de
                factuur niet direct naar je zorgverzekeraar sturen. In plaats hiervan moet je zelf je factuur indienen
                bij je zorgverzekeraar.{' '}
                <a
                    href="https://ksyos.webflow.io/service/kosten"
                    rel="noreferrer"
                    target="_blank"
                >
                    Hier vind je meer informatie over de kosten, de factuur en een handige stappenplan.
                </a>
            </p>
        ),
        id: 15,
        question: 'Waarom ontvang ik een factuur?',
    },
    {
        answer: (
            <>
                <p>
                    De factuur moet je indienen bij jouw zorgverzekeraar. Dit kun je meestal online doen via jouw
                    zorgverzekeraar-app of website, of door de factuur per post te versturen.
                </p>
                <p>
                    <strong>Stap voor stap uitleg over de vergoeding</strong>
                </p>
                <ol>
                    <li>
                        Je krijgt een mail van Ksyos met een factuur voor het slaaponderzoek. Open de mail en klik op
                        &apos;Factuurdossier&apos; Download de factuur en sla deze op.
                    </li>
                    <li>Ga naar de website of app van je zorgverzekeraar en upload de factuur van Ksyos.</li>
                    <li>
                        Het bedrag dat je ontvangt van je zorgverzekeraar staat na een aantal dagen op je bankrekening.
                        <br />
                        <br />
                        <strong>Informatie:</strong> Het bedrag dat je ontvangt van je zorgverzekeraar is lager dan het
                        bedrag op de eerste factuur. Je hoeft alleen het bedrag te betalen dat je van je zorgverzekeraar
                        hebt gekregen plus jouw openstaande eigen risico.
                    </li>
                    <li>
                        Je ontvangt van je zorgverzekeraar een overzicht. Download dit overzicht en upload deze in het
                        &apos;Factuurdossier&apos; in de e-mail van Ksyos.
                    </li>
                    <li>
                        Hierna krijg je van Ksyos een bericht met het bedrag dat je moet betalen. Maak dit bedrag binnen
                        30 dagen over aan Ksyos.
                    </li>
                </ol>
            </>
        ),
        id: 16,
        question: 'Wat moet ik met de factuur doen om geld terug te krijgen?',
    },
    {
        answer: (
            <>
                <p>
                    Het gaat om een polysommografie (PSG). Dit is de meest uitgebreide variant onder de
                    slaaponderzoeken. Een polysommografie registreert het volgende:
                </p>
                <ul>
                    <li>ademstops (apneus)</li>
                    <li>zuurstofgehalte</li>
                    <li>slaappositie</li>
                    <li>snurken</li>
                    <li>verschillende slaapfases</li>
                    <li>hartslag</li>
                    <li>beenbewegingen</li>
                </ul>
            </>
        ),
        id: 17,
        question: 'Wat voor slaaponderzoek voert VIVISOL uit?',
    },
    {
        answer: (
            <p>
                Een verpleegkundige van VIVISOL komt ’s avonds om de slaapapparatuur te bevestigen, vervolgens slaap je
                1 nacht met de slaapapparatuur. De volgende dag wordt de slaapapparatuur voor VIVISOL weer opgehaald.
            </p>
        ),
        id: 18,
        question: 'Hoelang duurt het slaaponderzoek (PSG) dat VIVISOL uitvoert?',
    },
    {
        answer: (
            <>
                <p>
                    Je wordt gevraagd om een paar dingen voor te bereiden, voordat de VIVISOL-verpleegkundige langskomt:
                </p>
                <ul>
                    <li>
                        Trek een schone pyjama of schoon T-shirt aan waarin je kunt slapen. Het is handig om een ruime
                        pyjamabroek of joggingbroek te dragen.
                    </li>
                    <li>
                        Voor de sensor aan je vinger is het belangrijk dat er geen nagellak of kunstnagels op je
                        wijsvinger of middelvinger zit, aan de hand die je het minst gebruikt.
                    </li>
                    <li>Zorg ook dat je haar gewassen en droog is, zonder haarlak of gel.</li>
                    <li>
                        In verband met het plaatsen van sensoren verzoeken wij je geen make up of crème op je gezicht te
                        gebruiken en indien mogelijk een gladgeschoren gezicht te hebben.
                    </li>
                    <li>Eventuele medicatie kun je blijven gebruiken.</li>
                    <li>
                        Vanwege de elektroden op het hoofd en in het gezicht zul je na het bezoek van de verpleegkundige
                        niet meer naar buiten kunnen.
                    </li>
                    <li>
                        De elektroden op het hoofd worden met een speciale pasta bevestigd. Houdt er rekening mee dat je
                        de volgende ochtend je haar zal willen wassen.
                    </li>
                </ul>
            </>
        ),
        id: 19,
        question: 'Hoe kan ik mijzelf voorbereiden op het slaaponderzoek dat wordt uitgevoerd door VIVISOL?',
    },
    {
        answer: (
            <p>
                De verpleegkundige van VIVISOL bezoekt je binnen het afgesproken tijdsblok. Je krijgt dan uitleg over
                het slaaponderzoek, vervolgens zal de verpleegkundige de apparatuur installeren, programmeren en de
                bijbehorende sensoren op uw lichaam bevestigen. Het bezoek van de verpleegkundige duurt ongeveer 45
                minuten.
            </p>
        ),
        id: 20,
        question: 'Wat gebeurt er als de verpleegkundige van VIVISOL langs komt?',
    },
    {
        answer: (
            <p>
                De volgende ochtend mag je de apparatuur zelf afdoen. De verpleegkundige heeft je uitgelegd hoe dit
                moet. Let erop dat je alle stekkertjes in het apparaat laat zitten! Op het afgesproken tijdstip wordt
                alles weer bij je opgehaald. Na het slaaponderzoek ontvang je een link om zelf een afspraak in te
                plannen met een arts.
            </p>
        ),
        id: 21,
        question: 'Wat gebeurt er na het slaaponderzoek van VIVISOL?',
    },
];
